export default __webpack_public_path__ + "static/Second-bb0c6d66d6b16d1668e801b37e10b6b4.jpg";